// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === 7596 ? "featherico" : chunkId) + "." + {4716: "1bea2ff458f4f77a",7596: "1745fba3d0b696b5",}[chunkId] + ".js"
}